<template>
    <b-card title="Filtro">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
            <b-row class="d-flex">
                <b-col xl="3" sm="12">
                    <b-form-group label="Año" label-for="year">
                        <v-select
                            v-model="filter.year"
                            class="pt-0" label="type" name="type"
                            :options="years"
                        />
                    </b-form-group>
                </b-col>

                <b-col xl="3" sm="12">
                    <b-form-group label="Instalación" label-for="installation">
                        <b-form-input
                            v-model="filter.gei_code"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col xl="2" sm="12">
                    <b-form-group label="Empresa" label-for="company">
                        <v-select
                            v-model="filter.company"
                            class="pt-0" label="name" name="name"
                            chips
                            multiple
                            :reduce="(option) => option.id"
                            :options="companiesList"
                        />
                    </b-form-group>
                </b-col>
                <b-col xl="3" sm="12">
                    <b-form-group label="Responsable" label-for="responsible">
                        <v-select
                            v-model="filter.responsible"
                            class="pt-0" label="name" name="name"
                            chips
                            multiple
                            :reduce="(option) => option.id"
                            :options="responsibles"
                        />
                    </b-form-group>
                </b-col>
                <b-col xl="3" sm="12">
                  <b-form-group label="Proveedor" label-for="provider">
                    <v-select
                        v-model="filter.provider"
                        class="pt-0" label="provider" name="provider"
                        chips
                        multiple
                        :reduce="(option) => option.id"
                        :options="providers"
                    />
                  </b-form-group>
                </b-col>
                <b-col xl="2" sm="12">
                    <b-form-group label="Tipologia" label-for="typology">
                        <v-select
                            v-model="filter.typology"
                            class="pt-0" label="name" name="name"
                            chips
                            multiple
                            :reduce="(option) => option.id"
                            :options="typologies"
                        />
                    </b-form-group>
                </b-col>

                <b-col xl="3" sm="12">
                    <b-button
                        class="mt-2"
                        variant="primary"
                        @click="search"
                    >
                        Filtrar
                    </b-button>
                    <b-button
                        class="mt-2 ml-2"
                        variant="primary"
                        @click="exportExcel"
                        v-if="showOnlyPlanned"
                    >
                        Exportar
                    </b-button>
                </b-col>
            </b-row>
        </b-overlay>
    </b-card>

</template>

<script>
import {BRow, BCol, BCard, BFormGroup, BFormInput, BButton, BOverlay} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import vSelect from "vue-select"

const {mapFields} = createHelpers({
    getterType: 'dashboardMetrics/getField',
    mutationType: 'dashboardMetrics/updateField',
})

export default {
    name: "FilterComponent",
    components: {
        BOverlay,
        BButton,
        BRow,
        BFormGroup,
        BCol,
        BCard,
        BFormInput,

        vSelect,
    },
    data() {
        return {
            years: [],
            companies: [
                {id: 1, name: 'ENDESA SOLUCIONES'},
                {id: 2, name: 'ENDESA ENERGIA'},
                {id: 3, name: 'ENDESA X'}
            ],
            segments: [
                {id: 1, name: 'Empresas'},
                {id: 2, name: 'Grandes Clientes'},
                {id: 3, name: 'Gran Publico'},
                {id: 4, name: 'Innovación desarrollo de negocio'},
            ],
            installations_active: [
                {id: 0, name: 'No'},
                {id: 1, name: 'Si'},
            ],
            responsibles: [],
            providers: [],
            typologies: [],
            companiesList: [],
        }
    },
    computed: {
        ...mapState('dashboardMetrics', ['dashboard_metrics']),
        ...mapFields({
            dashboard_metrics: 'dashboard_metrics',
            totals: 'totals',
            installation_list: 'installation_list',
            tabIndex: 'tabIndex',
            filter: 'filter',
            showLoading: 'showLoading',
            contentName: 'contentName'
        }),
        showOnlyPlanned: function () {
            const currentYear = new Date().getFullYear()

            return this.filter.year !== (currentYear + 1)
        },
    },
    created() {
        this.setYears()
        this.setCompanies()
        this.listAllResponsibles()
        this.listAllProviders()
        this.listAllTypologies()
        this.setUserCompanies()
    },
    methods: {
        setYears: function () {
            const date = new Date()
            let year = date.getFullYear()

            this.years = [year + 1, year, year - 1]
            this.filter.year = year
        },
        setUserCompanies() {
            const userCompanies = this.$store.state.AppActiveUser.companies
            this.filter.companies = userCompanies.map(company => company.id)
        },
        setCompanies() {
            this.showLoading = true

            const userCompanies = this.$store.state.AppActiveUser.companies

            if (!userCompanies || userCompanies.length === 0) {
                // Si no hay compañías en AppActiveUser, se obtiene la lista completa
                this.$store.dispatch('companies/getAllCompanies')
                    .then(response => {
                        this.companiesList = response
                    })
                    .catch(error => {
                        console.error("Error obteniendo compañías:", error)
                    })
                    .finally(() => {
                        this.showLoading = false
                    })
            } else {
                // Si ya hay compañias en AppActiveUser, se usan esas
                this.companiesList = userCompanies.map(company => ({
                    id: company.id,
                    name: company.name
                }))
                this.showLoading = false
            }
        },
        search() {
            this.showLoading = true

            this.$store.dispatch('dashboardMetrics/getDashboardMetrics', {
                filter: this.filter,
            })
                .then(response => {
                    this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                    console.log(error)
                })
        },
        exportExcel() {
            this.showLoading = true
            this.$store.dispatch('dashboardMetrics/generateInformDocumentExpirationExcel', {
                filter: this.filter,
            })
                .then(response => {
                    this.downloadExcel(response, `cuadro_de_mandos`)
                    this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        downloadExcel(response, filename) {
            const blob = new Blob([response])
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('target', '_blank')
            link.download = `${filename}.xlsx`
            link.click()
        },
        listAllResponsibles() {
            this.$store.dispatch('responsibles/getAllResponsibles')
              .then(response => {
                  this.responsibles = response
              })
              .catch(error => {
                  console.log(error)
              })
        },
        listAllProviders() {
          this.$store.dispatch('providers/getAllProviders')
            .then(response => {
              this.providers = response
            })
            .catch(error => {
              console.log(error)
            })
        },
        listAllTypologies() {
            this.$store.dispatch('typologies/listTypologies')
              .then(response => {
                  this.typologies = response
              })
              .catch(error => {
                  console.log(error)
              })
        }
    }
}
</script>

<style lang="scss">

</style>